module.exports = __webpack_public_path__ + "static/media/mission_impossible_amber.861b84b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/mission_impossible_amber.svg
// module id = 1100
// module chunks = 2